<template>
  <qb-panel :title="titulo.toUpperCase()" class="qb-margin-top">
    <vue-element-loading :active="!this.listaPronta"/>
    
    <card-group size="5" v-if="!vazio">
      <qb-card v-for="produto in produtos" :key="produto.id" :content="produto" v-on:card-click="show(produto.id)">
        <template v-slot:image>
          <img v-if="produto.images.length" :src="produto.images[0]" alt="foto produto"/> 
          <img v-else src="@/assets/sem-foto.png" alt="foto produto"/>
        </template>
        <button v-if="produto.stock > 0" class="btn btn-primary btn-full">Adicionar</button>
        <button v-if="produto.stock <= 0" class="btn btn-primary btn-full indisponivel">Indisponível</button>
      </qb-card>
    </card-group>

    <div v-if="vazio">
      <h3>Nenhum resultado para {{ this.$route.query.params }}</h3>
    </div>

    <div v-if="!vazio && paginaAtual < paginas" style="text-align: center; margin-top: 20px;">
      <button @click="carregarMais" class="btn btn-primary">Mais</button>
    </div>

    <div style="display: flex; width: 100%; justify-content: center;">
      <p v-if="vazio">Página - de -</p>
      <p v-else>Página {{paginaAtual}} de {{paginaAtual > 0 && paginas == 0 ? "1" : paginas}}</p>
    </div>

    <modal v-for="produto in produtos" :key="produto.id" :name="produto.id" :adaptive="true" height="auto" :resizable="true" :scrollable="true">
      <conteudo-modal-produto v-bind="produto" :idModal="produto.id"/>
    </modal>
  </qb-panel>
</template>

<script>
import axios from "axios";
import { baseApiUrl, baseImage } from "@/global";
import CardGroup from '../../components/card/card-group.vue';
import QbCard from '../../components/card/card.vue';
import ConteudoModalProduto from '../../components/modal/product-modal.vue';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'Lista',
  components: {
    CardGroup,
    QbCard,
    ConteudoModalProduto,
    VueElementLoading
  },
  data() {
    return {
      produtos: [],
      titulo: (this.$route.query.ofertas ? 'Ofertas' :
              this.$route.query.novidades ? 'Novidades' : 'Lista de produtos'),
      paginas: 0,
      paginaAtual: 0,
      listaPronta: false,
      vazio: false,
      baseImage: baseImage
    }
  },
  methods: {
    carregarProdutos(pagina = 1, append = false) {
      let url = `${baseApiUrl}/products/list/?page=${pagina}&brands=${this.$route.query.marcas || ''}&param=${this.$route.query.params || ''}&IdCategory=${this.$route.query.idCategoria || 0}&news=${this.$route.query.novidades ? true : false}&offers=${this.$route.query.ofertas ? true : false}&specifications=${this.$route.query.especificacao || ''}`;
      url += (this.$route.query.peso != '0|1700' ? `&peso=${this.$route.query.peso || ''}` : ``);
      url += (this.$route.query.tamanho != '0|2000' ? `&tamanho=${this.$route.query.tamanho || ''}` : ``);
      url += (this.$route.query.vazao != '0|2000' ? `&vazao=${this.$route.query.vazao || ''}` : ``);

      axios.get(url)
        .then(res => {
          if (res.status === 204 || !res.data.products.length) {
            this.vazio = true;
            this.listaPronta = true;
            return;
          }

          this.paginas = res.data.pages;
          this.paginaAtual = res.data.currentPage;
          this.produtos = append ? [...this.produtos, ...res.data.products] : res.data.products;
          this.listaPronta = true;
          this.vazio = false;
        })
        .catch(() => {
          this.listaPronta = true;
        });
    },
    carregarMais() {
      const proximaPagina = this.paginaAtual + 1;
      if (proximaPagina <= this.paginas) {
        this.listaPronta = false;
        this.carregarProdutos(proximaPagina, true);
      }
    },
    show(id) {
      this.$modal.show(id);
    }
  },
  created() {
    this.carregarProdutos();
  },
  beforeRouteUpdate(to, from, next) {
    this.listaPronta = false;
    this.produtos = []; // limpa produtos ao mudar rota
    this.vazio = false;
    this.paginaAtual = 0;
    next(); // continua a navegação
    this.carregarProdutos(); // recarrega os produtos com nova rota
  }
}
</script>

<style>
.indisponivel {
  background-color: gray!important;
}
.pagination {
  display: flex;
  justify-content: space-between;
  list-style: none;
  align-items: center;
}
.pagination li a {
  border: 1px solid black;
  padding: 8px 16px;
  margin: 0px 8px 0 0;
}
.page-item.active a {
  background-color: rgb(32, 176, 169);
  color: white;
}
.disabled a {
  color: white;
  background-color: black;
  cursor: not-allowed;
  opacity: 0.2;
}
li.page-item {
  display: none;
}
</style>
